import { Pipe, PipeTransform } from '@angular/core';
import { isNil, Nillable } from '@web/utils';
import { TableItemAction } from '../models/table-item-action';

@Pipe({
  name: 'onlyVisibleTableItemActions',
  standalone: true,
})
export class OnlyVisibleTableItemActionsPipe implements PipeTransform {
  public transform<Item, ItemAction>(
    actions: Nillable<Array<TableItemAction<Item, ItemAction>>>,
    item: Item,
  ): Nillable<Array<TableItemAction<Item, ItemAction>>> {
    if (isNil(actions)) {
      return actions;
    }

    return actions.filter((action) => action.visibility(item));
  }
}
